// extracted by mini-css-extract-plugin
export default {"downloadLink":"Ew22Ck"};